export default {
    set_error(state, value) {
        state.errors=[value]
    },
    reset_error(state) {
        state.errors=[]
    },
    set_loading(state, value) {
        state.loading=value
    },
    set_buildPickability(state, value) {
        state.buildPickability=value
    },
    set_pickWave(state, value) {
        state.pickWave=value
    },
    set_pickWaves(state, value) {
        state.pickWaves=value
    },
    set_pickingLocations(state, value) {
        // On garde le `picked` renvoyé par le serveur au lieu de le remettre à
        // zéro.
        //
        // Depuis que le picking peut se faire au téléphone (route /pick du
        // middleware React), l'avancement vit en base — table `pick_task` — et
        // non plus seulement dans ce store. Repartir de zéro ici ferait
        // afficher « 0 pris » sur une wave déjà avancée, et surtout
        // `commitPickup` enverrait 0 en valeur absolue : le serveur convertit
        // désormais cet absolu en delta, donc il ANNULERAIT le picking déjà
        // enregistré et remettrait la marchandise en stock.
        value = value.map(item => {item.picked = item.picked || 0; return item})
        state.pickingLocations=value
    },
    pick_item(state, params){
        const {code, quantity, location} = params;
        let pickingLocations = [...state.pickingLocations];
        let item = null
        if(location) {
            item = pickingLocations.find(loc => loc.product.code === code && loc.location.id === location);
        }else{
            item = pickingLocations.find(loc => loc.product.code === code);
        }
        if(item.picked){
            item.picked += quantity;
        }else{
            item.picked = quantity;
        }

        state.pickingLocations = pickingLocations;
    },
    reset_picking(state, itemIndex){
        let pickingLocations = [...state.pickingLocations];
        pickingLocations[itemIndex].picked = 0;
        state.pickingLocations = pickingLocations;
    },
    toggle_pickwave(state, build){
        let buildInPickwave = [...state.buildInPickwave];
        let index = buildInPickwave.findIndex(b => b.id === build.id);
        if(index >= 0){
            buildInPickwave = buildInPickwave.filter(b => b.id !== build.id);
        }else{
            buildInPickwave.push(build);
        }
        state.buildInPickwave = buildInPickwave
    },
    reset_buildInPickwave(state){
        state.buildInPickwave=[]
    }
}